import { Component, OnDestroy, PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

import { Observable, Subscription, filter } from 'rxjs';

import { NavigationMenuService, ScrollService } from '@fcom/common/services';
import { unsubscribe } from '@fcom/core/utils';
import { isNavigationEvent } from '@fcom/common/utils';

@Component({
  selector: 'fin-language-setting-layout',
  templateUrl: './language-setting-layout.component.html',
  styleUrls: [],
  standalone: false,
})
export class LanguageSettingLayoutComponent implements OnDestroy {
  private navigationMenuService = inject(NavigationMenuService);
  private router = inject(Router);
  private scrollService = inject(ScrollService);
  private platform = inject(PLATFORM_ID);

  subscriptions: Subscription = new Subscription();
  isFooterOpen$: Observable<boolean>;

  constructor() {
    this.subscriptions.add(
      this.router.events
        .pipe(
          filter(isNavigationEvent),
          filter(() => isPlatformBrowser(this.platform))
        )
        .subscribe(() => {
          this.scrollService.scrollTop();
        })
    );
    this.isFooterOpen$ = this.navigationMenuService.isFooterOpen$;
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
